export default __webpack_public_path__ + "static/media/hair.5191666c.png";